import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const typeOfBusiness = async (): Promise<any> => {
  const typeofbusiness = useJSONStore.getState().typeOfBusiness;
  const token = useUserStore.getState().userToken;
  const setTypeOfBusiness = useJSONStore.getState().setTypeOfBusiness;

  if (typeofbusiness.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.typeofbusiness}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setTypeOfBusiness(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default typeOfBusiness;
